import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {UserService} from '@feature-module/user/services/user.service';
import {userList, userListSuccess} from '@core/redux/core.actions';
import {exhaustMap, map} from 'rxjs/operators';

@Injectable()
export class CoreEffects {


  constructor(private actions$: Actions,
              private userService: UserService) {
  }

  getUserList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userList),
      exhaustMap(value =>
        this.userService.getObjects().pipe(
          map(result => userListSuccess({
            users: result
          }))
        )
      )
    )
  );
}
